'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _enums = require('MeetingsBase/constants/enums');

var _UIList = require('UIComponents/list/UIList');

var _UIList2 = _interopRequireDefault(_UIList);

var _UIFormControl = require('UIComponents/legacy/UIFormControl');

var _UIFormControl2 = _interopRequireDefault(_UIFormControl);

var _UINumberInput = require('UIComponents/input/UINumberInput');

var _UINumberInput2 = _interopRequireDefault(_UINumberInput);

var _UIRadioInput = require('UIComponents/input/UIRadioInput');

var _UIRadioInput2 = _interopRequireDefault(_UIRadioInput);

var _UICheckbox = require('UIComponents/input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UITextInput = require('UIComponents/input/UITextInput');

var _UITextInput2 = _interopRequireDefault(_UITextInput);

var _UITextArea = require('UIComponents/input/UITextArea');

var _UITextArea2 = _interopRequireDefault(_UITextArea);

var _UISelectInput = require('UIComponents/input/UISelectInput');

var _UISelectInput2 = _interopRequireDefault(_UISelectInput);

var _UIToggleGroup = require('UIComponents/input/UIToggleGroup');

var _UIToggleGroup2 = _interopRequireDefault(_UIToggleGroup);

var _UIDateInput = require('UIComponents/input/UIDateInput');

var _UIDateInput2 = _interopRequireDefault(_UIDateInput);

var _SimpleDate = require('UIComponents/core/SimpleDate');

var _ComponentWithPartials = require('UIComponents/mixins/ComponentWithPartials');

var _ComponentWithPartials2 = _interopRequireDefault(_ComponentWithPartials);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var BookingFormField = _react2.default.createClass({
  displayName: 'BookingFormField',

  mixins: [_ComponentWithPartials2.default],

  propTypes: {
    fieldValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array, _react.PropTypes.object, _react.PropTypes.number]),
    fieldName: _react.PropTypes.string.isRequired,
    validation: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
    setFormValue: _react.PropTypes.func.isRequired,
    autocomplete: _react.PropTypes.string,
    fieldType: _react.PropTypes.string,
    type: _react.PropTypes.string,
    isRequired: _react.PropTypes.bool,
    fieldLabel: _react.PropTypes.string,
    fieldOptions: _react.PropTypes.array,
    fieldIsCustom: _react.PropTypes.bool,
    placeholder: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autocomplete: 'off'
    };
  },
  getInitialState: function getInitialState() {
    return {
      hasBeenBlurred: false
    };
  },
  isNameField: function isNameField() {
    return ['firstName', 'lastName'].includes(this.props.fieldName);
  },
  getEnumOptions: function getEnumOptions(options) {
    return options.map(function (option) {
      return { text: option.label, value: option.value };
    });
  },
  onFieldBlur: function onFieldBlur() {
    this.setState({ hasBeenBlurred: true });
  },
  handleEnumValueChange: function handleEnumValueChange(_ref) {
    var fieldName = _ref.fieldName,
        value = _ref.value;

    this.props.setFormValue(fieldName, value);
  },
  handleValueChange: function handleValueChange(fieldName, e) {
    this.props.setFormValue(fieldName, e.target.value);
  },
  handleDateValueChange: function handleDateValueChange(fieldName, e) {
    this.props.setFormValue(fieldName, (0, _SimpleDate.toMomentUTC)(e.target.value).valueOf());
  },
  renderStandardField: function renderStandardField(FormFieldComponent) {
    var _props = this.props,
        fieldName = _props.fieldName,
        fieldValue = _props.fieldValue,
        autocomplete = _props.autocomplete,
        placeholder = _props.placeholder;


    return _react2.default.createElement(FormFieldComponent, {
      style: { maxWidth: '100%' },
      autoComplete: autocomplete,
      type: 'text',
      name: fieldName,
      className: 'confirm-' + fieldName + '-field',
      value: fieldValue || '',
      onChange: this.partial(this.handleValueChange, fieldName),
      onBlur: this.onFieldBlur,
      placeholder: placeholder
    });
  },
  renderTextField: function renderTextField() {
    return this.renderStandardField(_UITextInput2.default);
  },
  renderTextAreaField: function renderTextAreaField() {
    return this.renderStandardField(_UITextArea2.default);
  },
  renderEnumType: function renderEnumType(renderFunction) {
    var fieldOptions = this.props.fieldOptions;

    return _react2.default.createElement(
      _UIList2.default,
      null,
      fieldOptions.map(function (option) {
        if (option.value !== '') {
          return renderFunction(option);
        }
        return null;
      })
    );
  },
  renderCheckbox: function renderCheckbox(option) {
    var _props2 = this.props,
        fieldName = _props2.fieldName,
        fieldValue = _props2.fieldValue;


    return _react2.default.createElement(
      _UICheckbox2.default,
      {
        key: option.value,
        checked: option.value === fieldValue,
        onChange: this.partial(this.handleEnumValueChange, {
          fieldName: fieldName,
          value: option.value
        }),
        onBlur: this.partial(this.onFieldBlur, { target: { name: fieldName } })
      },
      option.label
    );
  },
  renderRadioInput: function renderRadioInput(option) {
    var _props3 = this.props,
        fieldName = _props3.fieldName,
        fieldValue = _props3.fieldValue;


    return _react2.default.createElement(_UIRadioInput2.default, {
      key: option.value,
      name: option.value,
      text: option.label,
      checked: option.value === fieldValue,
      onChange: this.partial(this.handleEnumValueChange, {
        fieldName: fieldName,
        value: option.value
      }),
      onBlur: this.partial(this.onFieldBlur, { target: { name: fieldName } })
    });
  },
  renderSelectField: function renderSelectField() {
    var _props4 = this.props,
        fieldName = _props4.fieldName,
        fieldType = _props4.fieldType,
        fieldOptions = _props4.fieldOptions,
        fieldValue = _props4.fieldValue,
        setFormValue = _props4.setFormValue,
        placeholder = _props4.placeholder;


    var placeholderText = _I18n2.default.text('select') || placeholder;

    if (fieldType === _enums.FORM_FIELD_TYPES.CHECKBOX) {
      var valueArray = fieldValue || [];

      return _react2.default.createElement(
        _UIToggleGroup2.default,
        { name: fieldName },
        fieldOptions.map(function (option) {
          var selected = valueArray.includes(option.value);
          var onChange = selected ? function () {
            return setFormValue(fieldName, valueArray.filter(function (value) {
              return value !== option.value;
            }));
          } : function () {
            return setFormValue(fieldName, [].concat(_toConsumableArray(valueArray), [option.value]));
          };
          return {
            onChange: onChange,
            selected: selected,
            key: option.value,
            label: option.label
          };
        }).map(function (option) {
          var key = option.key,
              label = option.label,
              props = _objectWithoutProperties(option, ['key', 'label']);

          return _react2.default.createElement(
            _UICheckbox2.default,
            _extends({ key: key }, props),
            label
          );
        })
      );
    } else {
      return _react2.default.createElement(_UISelectInput2.default, {
        name: fieldName,
        onChange: this.partial(this.handleValueChange, fieldName),
        onBlur: this.onFieldBlur,
        options: this.getEnumOptions(fieldOptions),
        placeholder: placeholderText,
        value: fieldValue || ''
      });
    }
  },
  renderEnumerationFields: function renderEnumerationFields() {
    var fieldType = this.props.fieldType;


    switch (fieldType) {
      case _enums.FORM_FIELD_TYPES.BOOLEAN_CHECKBOX:
        return this.renderEnumType(this.renderCheckbox);
      case _enums.FORM_FIELD_TYPES.RADIO:
        return this.renderEnumType(this.renderRadioInput);
      default:
        return this.renderSelectField();
    }
  },
  renderNumberField: function renderNumberField() {
    var _props5 = this.props,
        fieldName = _props5.fieldName,
        fieldValue = _props5.fieldValue;


    return _react2.default.createElement(_UINumberInput2.default, {
      name: fieldName,
      onChange: this.partial(this.handleValueChange, fieldName),
      onBlur: this.onFieldBlur,
      value: fieldValue
    });
  },
  renderDateField: function renderDateField() {
    var fieldName = this.props.fieldName;


    return _react2.default.createElement(
      'div',
      { className: 'meetings-date-input' },
      _react2.default.createElement(_UIDateInput2.default, {
        name: fieldName,
        icon: true,
        placeholder: _I18n2.default.moment.localeData().longDateFormat('L') || 'MM/DD/YYYY',
        onChange: this.partial(this.handleDateValueChange, fieldName),
        onBlur: this.onFieldBlur
      })
    );
  },
  renderInput: function renderInput() {
    var _props6 = this.props,
        fieldIsCustom = _props6.fieldIsCustom,
        type = _props6.type,
        fieldType = _props6.fieldType;


    switch (true) {
      case type === _enums.FORM_FIELD_TYPES.ENUMERATION:
        return this.renderEnumerationFields();
      case type === _enums.FORM_FIELD_TYPES.NUMBER:
        return this.renderNumberField();
      case type === _enums.FORM_FIELD_TYPES.DATE:
        return this.renderDateField();
      case fieldIsCustom || fieldType === _enums.FORM_FIELD_TYPES.TEXTAREA:
        return this.renderTextAreaField();
      default:
        return this.renderTextField();
    }
  },
  render: function render() {
    var _props7 = this.props,
        validation = _props7.validation,
        isRequired = _props7.isRequired,
        fieldLabel = _props7.fieldLabel;


    var hasError = Boolean(validation) && this.state.hasBeenBlurred;
    var validationMessage = void 0;
    if (hasError) {
      validationMessage = validation;
    }
    var classes = (0, _reactUtils.classNames)({ 'm-top-6': !this.isNameField() });

    return _react2.default.createElement(
      _UIFormControl2.default,
      {
        className: classes,
        label: fieldLabel,
        required: isRequired,
        error: hasError,
        validationMessage: validationMessage,
        onBlur: this.onFieldBlur
      },
      this.renderInput()
    );
  }
});

exports.default = BookingFormField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/input/BookingFormField.js
// module id = 133
// module chunks = 0